import { EmailMessage } from '../../hooks/useEmailAPI';

interface EmailListItemProps {
  email: EmailMessage;
  isSelected: boolean;
  onClick: () => void;
}

const EmailListItem = ({ email, isSelected, onClick }: EmailListItemProps) => {
  return (
    <div 
      className={`p-4 border-b cursor-pointer transition-colors ${
        isSelected ? 'bg-[#fff5eb]' : 'hover:bg-gray-50'
      } ${!email.isRead ? 'font-semibold' : ''}`}
      onClick={onClick}
    >
      <div className="flex justify-between items-start mb-1">
        <div className="font-medium text-[#694e42]">{email.from}</div>
        <div className="text-xs text-[#8a7266]">
          {new Date(email.receivedAt).toLocaleDateString()}
        </div>
      </div>
      <div className="text-[#694e42] mb-1">{email.subject}</div>
      <div className="text-sm text-[#8a7266] truncate">{email.body}</div>
    </div>
  );
};

export default EmailListItem;